import { getImage } from "../utils";


export function fullScreenBannerProxy(component: any): any {

    const componentType = component?.fields?.componentType;

    const banner =
        component?.fields?.entries?.map((entry: any) => {
            const {
                bannerBackground,
                bannerDescription,
                bannerDisclaimer,
                bannerLogo,
                bannerTitle,
                buttonHref,
                buttonLabel,
                erroCodeHandler,
            } = entry?.fields ?? {};


            const errorCodes = erroCodeHandler?.map((errorCode: any) => {
                return errorCode?.fields
            })

            return {
                bannerTitle,
                bannerDescription,
                bannerDisclaimer,
                buttonHref,
                buttonLabel,
                bannerLogo: getImage(bannerLogo),
                bannerBackground: getImage(bannerBackground),
                errorCodes,
            };
        })?.[0] ?? {};
    return {
        componentType,
        banner
    };
}
